module.exports = __webpack_public_path__ + "static/media/Thirdpartypet.627e2745.png";